// copy from @mmodboard/theme/pxToRemNum
const REM_VALUE = 9.79;

const pxToRemNum = (size: number): number => {
  // REM_VALUE (9.79) - is the value of 1 rem this is adjustable
  return size / REM_VALUE;
};

export default pxToRemNum;
